// MARK: React
import * as React from "react";
import { observer } from "mobx-react";
import "./style.scss";

// MARK: API
import { translateBedroomConfort } from "@startapp/mistral-admin-api";

// MARK: Components
import { Typography } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";

import SelectOptions from "../../../../../components/SelectOptions";
import TextField from "../../../../../components/TextField";
import Button from "../../../../../components/Button";
import Divider from "../../../../../components/Divider";
import Dialog from "../../../../../components/Dialog";

// MARK: Stores
import BedroomStore from "../../../../../stores/BedroomStore";

// MARK: Resources
import strings from "../../../../../resources/strings";

interface IProps {
	bedroomStore: BedroomStore;
}

@observer
export default class BedroomComfortSection extends React.Component<IProps> {
	public async componentDidMount()  {
		this.props.bedroomStore.getBedroomComfort();
	}
		public render() {
		const { bedroomStore } = this.props;
		return (
			<>
				<Divider className="divider"/>
				<h2>{strings.bedrooms.createOrEdit.sections.specifications.title}</h2>
				<Button onClick={bedroomStore.openModal}>
					{strings.bedrooms.createOrEdit.buttons.add}
				</Button>
				{
					bedroomStore.bedroomSpecification.map((specification) => {
						return (
							<div key={specification.type + specification.details} className="listSpecifications">
								<div className="type">
									<img
										src={`/icons/${specification.type}.png`}
										alt={translateBedroomConfort(specification.type)}
										title={translateBedroomConfort(specification.type)}
									/>
								</div>
								<div className="description">
									{specification.details}
								</div>
								<Button
									onClick={() => bedroomStore.removeSpecificationDetails(specification)}
								>
									<CloseIcon/>
								</Button>
							</div>
						);
					},
				)}
				<Dialog open={bedroomStore.modal}>
					<div className="specificationsModal">
						<Typography variant="h5">{strings.bedrooms.createOrEdit.sections.specifications.add}</Typography>
						<div className="boxSpecifications">
							<div className="boxInputSpecifications">
								<SelectOptions
									title={strings.bedrooms.createOrEdit.sections.specifications.type}
									values={bedroomStore.bedroomComforts}
									translatorValue={translateBedroomConfort}
									changeValue={bedroomStore.selectSpecificationType}
									selectedValue={bedroomStore.bedroomComfortType}
								/>
							</div>
							<div className="boxInputSpecifications">
								<TextField
									name="bedroomComfortDescription"
									value={bedroomStore.bedroomComfortDescription}
									onChange={bedroomStore.handleValueChange}
									label={strings.bedrooms.createOrEdit.sections.specifications.description}
								/>
							</div>
							<div className="boxSpecificationsButtons">
								<Button onClick={bedroomStore.closeModal}>
									{strings.bedrooms.createOrEdit.sections.specifications.cancel}
								</Button>
								<Button onClick={bedroomStore.saveSpecificationDetails} variant="contained">
									{strings.bedrooms.createOrEdit.buttons.add}
								</Button>
							</div>
						</div>
					</div>
				</Dialog>
			</>
		);
	}
}
